import React from 'react';
import Raupō from '../../assets/raupo';
import FooterSpace from '../footer/FooterSpace';
import HeaderSpace from '../header/HeaderSpace';

const NotFound = () => {

    return (
        <>
            <Raupō nama={20}/>
            <HeaderSpace />
            <div className='mx-auto min-h-[calc(100vh-76px)] pt-20 pb-8 px-4 max-w-200 md:min-h-[calc(100vh-60px)]'>
                <h2 className="text-5xl pt-12 font-normal text-center text-toto-1">Auē!</h2>
                <h2 className="text-5xl mb-8 mt-2 font-normal text-center text-toto-1">Kua ngaro :/</h2>
                <div className="flex flex-col items-center justify-center w-full">
                    <p className="mt-2 w-full md:w-130 md:text-xl">Kua ngaro tēnei whārangi, kua ngaro rānei koe!</p>
                    <p className="mt-2 w-full md:w-130 md:text-xl">Either this page is lost, or you are...</p>
                </div>
            </div>
            <FooterSpace />
        </>
    )
}

export default NotFound